import { render, staticRenderFns } from "./PreRegisterCampaign.vue?vue&type=template&id=5315c5db&scoped=true"
import script from "./PreRegisterCampaign.vue?vue&type=script&lang=js"
export * from "./PreRegisterCampaign.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterCampaign.vue?vue&type=style&index=0&id=5315c5db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315c5db",
  null
  
)

export default component.exports